export default __webpack_public_path__ + "static/media/maykel.53c14fee.png";